import { render, staticRenderFns } from "./invoicehead.vue?vue&type=template&id=caf804aa&scoped=true"
import script from "./invoicehead.vue?vue&type=script&lang=js"
export * from "./invoicehead.vue?vue&type=script&lang=js"
import style0 from "./invoicehead.vue?vue&type=style&index=0&id=caf804aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf804aa",
  null
  
)

export default component.exports